import { gql } from "@apollo/client/core";
import SpecialConditionTypeFragment from "../fragments/SpecialConditionType";

// Special-condition mappings are revision-scoped (RTLCA-5259), so a projectId filter alone matches
// every revision's copy of a row at once. The default pins to the working state, which is what an
// unpinned caller means; pass revisionScopeFilter(pin) to read a frozen revision's own rows.
const GetProjectSpecialConditionTypeMappings = gql`
  query GetProjectSpecialConditionTypeMapping(
    $buildingProjectId: uuid!
    $model: String!
    $typeIdentifiers: [String!]!
    $revisionFilter: projectSpecialConditionTypeMapping_bool_exp = { revision: { frozenAt: { _is_null: true } } }
  ) {
    projectSpecialConditionTypeMapping(
      where: {
        projectId: { _eq: $buildingProjectId }
        model: { _eq: $model }
        typeIdentifier: { _in: $typeIdentifiers }
        _and: [$revisionFilter]
      }
    ) {
      areaOfConstruction
      description
      id
      length
      model
      specialConditionType {
        ...specialConditionTypeFragment
      }
      typeIdentifier
    }
  }
  ${SpecialConditionTypeFragment}
`;

export default GetProjectSpecialConditionTypeMappings;
